import { takeLatest } from "redux-saga/effects"
import ActionTypes from "../../enums/ActionTypes"
import { API_SERVER_USER } from "../../constants/api"
import { createLock } from "./createLock"

type LockScreenResponse = {
  screenToken: string
}

const lockScreen = createLock({
  resourcePath: `${API_SERVER_USER}/screens`,
  successAction: ActionTypes.SCREEN_LOCK_SUCCESS,
  failureAction: ActionTypes.SCREEN_LOCK_FAILURE,
  successMessage: "pages.screen.activated",
  failureMessage: "pages.screen.notActivated",
  getTokenFromResponse: (res: LockScreenResponse) => res.screenToken,
})

const screenSagas = [
  takeLatest(ActionTypes.SCREEN_LOCK_REQUEST, lockScreen),
]

export default screenSagas